import React from 'react'
import './App.css'
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import Home from './Pages/Home/Home.js'
import About from './Pages/About/About.js'
import Work from './Pages/Work/Work.js'
import Header from './Components/Header/Header'
import Footer from './Components/Footer/Footer'
import Loader from './Components/Loader/Loader'
export function Nav() {
  return (
    <Router>
      <Header />
      {/* <Home/> */}
      <Routes>
        {/* <Route path="/about">
          <About />
        </Route>
        <Route path="/topics">
          <Topics />
        </Route> */}
        <Route path="/" element={<Home />} />
        <Route path="/About" element={<About />} />
        <Route path="/Work/:id" element={<Work />} />
      </Routes>
      < Footer />
    </Router>
  )
}


function App() {
  const [loading, setLoading] = React.useState(false)

  React.useEffect(() => {
    setTimeout(() => setLoading(true), 4000)
  }, [])

  return loading ? <Nav /> : <Loader />
}

export default App
